
export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;

// OneSignal configuration (set in .env)
export const ONESIGNAL_APP_ID = process.env.REACT_APP_ONESIGNAL_APP_ID;